export default function Input({ className = "", ...props }) {
  return (
    <input
      className={
        "w-full px-4 py-2.5 rounded-xl border bg-[rgb(var(--card))] text-[rgb(var(--fg))] text-sm " +
        "border-[rgb(var(--border))] outline-none " +
        "focus:border-[rgb(var(--primary))] focus:ring-2 focus:ring-[rgba(var(--primary),0.15)] " +
        "placeholder:text-[rgb(var(--fg))] placeholder:opacity-30 transition-shadow transition-colors " +
        className
      }
      {...props}
    />
  );
}